<template>
  <div class="float-right">
    
    <a href="#"
      v-if="orderBy == orderKey"
      v-on:click.prevent="updateOrderBy(orderKey)"
      :class="{ 'float-right rounded-sm no-underline' : true,  'bg-gray-600 text-white' : orderBy == orderKey, 'hover:bg-gray-300 text-gray-600' : orderBy != orderKey }"
      style="margin-top:-2px;padding:0 1px;"
      v-tooltip.top="{ html : 'orderBy' + orderKey }">
      
      <template v-if="orderType == 'asc'">
        <svg width="14" height="14" stroke-width="2" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-up"/>
        </svg>
      </template>

      <template v-else>
        <svg width="14" height="14" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-down"/>
        </svg>
      </template>
    </a>

    <a href="#"
      v-else
      v-on:click.prevent="updateOrderBy(orderKey)"
      :class="{ 'float-right rounded-sm no-underline' : true, 'hover:bg-gray-200 text-gray-600' : orderBy != orderKey }"
      style="margin-top:-4px;padding:0 2px;"
      v-tooltip.top="{ html : 'orderBy' + orderKey }">

      <div class="">
        <svg width="10" height="10" stroke-width="2" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-up"/>
        </svg>
      </div>

      <div class="" style="margin-top:-1px;">
        <svg width="10" height="10" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-down"/>
        </svg>
      </div>
    </a>

    <div :id="'orderBy'+ orderKey">
      <a href="#"
        class="block text-white no-underline hover:underline text-sm"
        v-on:click.prevent="updateOrderBy(orderKey)">Sort by <b>{{ orderKeyLabel }}</b> in ascending order</a>

      <a href="#"
        class="block text-white no-underline hover:underline text-sm"
        v-on:click.prevent="updateOrderBy(orderKey)">Sort by <b>{{ orderKeyLabel }}</b> in descending order</a>
    </div>
  </div>
</template>

<script>
  export default {

    props : {
      updateOrderBy : {
        type    : Function,
        required: false
      },

      orderType : {
        type    : String,
        required: false
      },

      orderBy : {
        type    : String,
        required: false
      },

      orderKey : {
        type : String,
        required : false
      },

      orderKeyLabel : {
        type : String,
        required : false
      }
    }
  }
</script>